<template>
  <div class="main">
    <div class="header">
      <Header
        @toLocation="toLocation"
        :headerMenuSelectedKey="headerMenuSelectedKey"
        :shrinkMenuSelectedKey="subMenuSelectedKey"/>
    </div>
    <div class="header-banner-box">
      <img src="static/header/banner.png" class="header-banner"/>
    </div>
    <!--    内容-->
    <div class="content">
      <div class="content-one">
        <img src="static/image/display/u931.png" class="display-img"/>
        <div class="display-img-one-right">
          <h2>品牌：</h2>
          <p>医疗集团</p>
          <br><br>
          <h2>服务类别：</h2>
          <br>
          <p>多项服务内容</p>
          <br><br>
          <h2>项目简介：</h2>
          <br>
          <p>医疗集团希望通过线上平台招募有影响力的学者，专家，对产品的某一特别功效进行科学的解答和宣传。</p>
        </div>
      </div>
      <div>
        <img src="static/image/display/u932.png" class="display-img-two"/>
      </div>
      <div>
        <img src="static/image/display/u933.png" class="display-img"/>
      </div>
      <div>
        <img src="static/image/display/u934.png" class="display-img"/>
      </div>
      <div>
        <img src="static/image/display/u935.png" class="display-img"/>
      </div>
      <div>
        <img src="static/image/display/u936.png" class="display-img"/>
      </div>
    </div>
    <!--    企业微信-->
    <div class="enterpriseWechat">
      <EnterpriseWechat/>
    </div>
    <div class="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnterpriseWechat from "../components/EnterpriseWechat";

export default {
  components: {Header, Footer, EnterpriseWechat},
  data() {
    return {
      headerMenuSelectedKey: 'home',//todo
      subMenuSelectedKey: '',//todo
    };
  },
  watch: {},
  created() {

  },
  mounted() {
    document.title = "案例展示";
  },
  methods: {
    toLocation(location) {
      this.subMenuSelectedKey = location
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(249, 249, 249, 1);
}

.header {
  width: 1920px;
  height: 60px;
}

.enterpriseWechat {
  position: fixed;
  top: 45%;
  right: 0;
}
.header-banner-box {
  width: 100%;
  height: 220px;
}
.header-banner{
  width:100%;
  height: 220px;
}

.content {
  width: 1400px;
  height: auto;

}
.display-img {
  width: 799px;
  height: 533px;
  margin-bottom: 20px;
}
.display-img-one-right {
  width: 369px;
  height: 345px;
  border-radius: 15px;
  background: #FFFFFF;
  font-size: 18px;
padding: 20px;
}
.display-img-one-right h2 {
  font-size: 18px;
  color: #D1121C;
  float: left;
}

.content-one {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-top: 100px;
}
.display-img-two {
  width: 799px;
  height: 371px;
  margin-bottom: 20px;
}
.footer {
  height: 189px;
  width: 1920px;
  overflow: hidden;
  position: relative;
  bottom: 0;

}
</style>



// WEBPACK FOOTER //
// src/views/CaseDisplay.vue